import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import i18n from '@gik/i18n';
import { translationKeys } from '@gik/create/i18n/en';
import { FormProps, SvgIcon } from '@gik/ui';
import { ICreateFeaturesWishlistFormValues, WishlistFeatureStep } from '@gik/create/components/FeatureStep/FeatureStep';
import { CreatePageContext } from '@gik/create/components/CreatePage/CreatePage';
import { FeaturesStepInputNames } from '@gik/create/enums/FeaturesStepInputNames';

export interface IWishlistStepProps extends FormProps {
  onSubmit?: (values: ICreateFeaturesWishlistFormValues) => void;
  onChange?: (values: ICreateFeaturesWishlistFormValues) => void;
}

const blockName = 'wishlist-step';

export default function WishlistStep({ ...otherProps }) {
  const bem = bemBlock(blockName);
  const { wishlistFormRef } = React.useContext(CreatePageContext);

  return (
    <WishlistFeatureStep
      ref={wishlistFormRef}
      formName={FeaturesStepInputNames.Wishlist}
      className={bem()}
      icon={<SvgIcon className={bem('icon')} set={'gik-icons'} name={'Wishlist'} />}
      title={i18n.t(translationKeys.WishlistTitle)}
      description={i18n.t(translationKeys.WishlistCreateStepDescription)}
      {...otherProps}
    />
  );
}
